import React from "react";
import QRcode from "../qrcode";
import CompanyInfo from "../CompanyInfo";
import useFetch from "../../hooks/useFetch";

const Footer = () => {

  const contactMsg = useFetch('http://1.94.62.64:9090/myf/getConnect')
  
  return (
    <div className="bg-gradient-to-r from-cyan-300 to-blue-400 py-2">
      <div className='flex justify-center mt-20'>
        <QRcode />
        <div className="ml-24">
          <CompanyInfo contactMsg={contactMsg} />
        </div>
      </div>
      <div className="from-slate-200 w-full border border-b-0"></div>
      <div className="flex justify-center space-x-3 mt-1">
        <a href="https://beian.miit.gov.cn/" target="_blank" className="text-sm">沪ICP备2023001914号</a>
        <p className="flex justify-center">
          <a href="https://beian.miit.gov.cn/" target="_blank" className="text-sm">沪公网安备31011302007236号</a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
